var exports = {
  "ne": "xdde3148b--2e67f3--controls",
  "DD": "xdde3148b--2e67f3--title",
  "VN": "xdde3148b--2e67f3--close",
  "o1": "xdde3148b--2e67f3--actions",
};

module.exports = exports;
